export default {
  attachmentItemComponent: 'attachment-item-pill',
  allowMediaInserter: false,
  allowMention: true,
  allowAttribute: false,
  autoFocusBottomRight: false,
  autoFocusTopLeft: false,
  urlReplacement: false,
  allowButton: false,
  allowSocial: false,
  allowHeading: true,
  allowSubheading: true,
  recoverErrors: true,
  allowEmoji: true,
  allowSavedReplies: false,
  allowMarkdownHeadings: false,
  markdownInlineCode: true,
  stripEmptyTrailingBlocks: true,
  allowImage: false,
  allowVideo: false,
  allowUploads: false
};